import { LeadForm } from "./leadForm";
import { useLeadsStore } from "../../../../Stores/LeadAndCustomer/leadsStore";

interface NewLeadModalContentProps {
  onClose: () => void;
}

export const NewLeadModalContent = ({ onClose }: NewLeadModalContentProps) => {
  const { fetchLeads } = useLeadsStore();

  const handleModalClose = async () => {
    // Refresh the leads list to include the new lead
    await fetchLeads();
    onClose();
  };

  return (
    <div>
      <h2 className="text-2xl font-bold text-blue-700 mb-6 text-center">מתעניין חדש</h2>
      <LeadForm onModalClose={handleModalClose} />
    </div>
  );
};